// ShadingInput.jsx
import React, { useState } from "react";
import "./ShadingInput.css";

const shadingCauses = [
  { name: "Trees", emoji: "🌳" },
  { name: "Buildings", emoji: "🏢" },
  { name: "Chimney", emoji: "🔥" },
  { name: "Other", emoji: "🛠️" },
];

const shadingTimes = ["Morning", "Afternoon", "all-day"];

export default function ShadingInput({ nextStep, updateFormData }) {
  const [shadePercent, setShadePercent] = useState(0);
  const [selectedCauses, setSelectedCauses] = useState([]);
  const [selectedTime, setSelectedTime] = useState("");

  const toggleCause = (cause) => {
    setSelectedCauses((prev) =>
      prev.includes(cause)
        ? prev.filter((c) => c !== cause)
        : [...prev, cause]
    );
  };

  const handleContinue = () => {
    if (shadePercent > 0 && selectedTime === "") {
      alert("Please select when shading occurs.");
      return;
    }

    updateFormData({
      shadingPercent: shadePercent,    // <-- key renamed to shadingPercent
      shadingCauses: selectedCauses,
      shadingTime: selectedTime,
    });
    nextStep();
  };

  return (
    <div className="shading-container">
      <div className="shading-card">
        <h2>How much is your sunniest roof shaded?</h2>
        <p className="shading-info">
          Shading can have a big impact on solar energy production. Tell us if your sunniest roof has any shading through the day and to what extent. <em>Leave the slider at 0% if no shading occurs or move slider to show what percentage of the roof is shaded and then tell us when the shading occurs.</em>
        </p>
        <div className="slider-labels">
          <span>0%</span>
          <input
            type="range"
            min="0"
            max="100"
            value={shadePercent}
            onChange={(e) => setShadePercent(Number(e.target.value))}
          />
          <span>100%</span>
        </div>
        <p>{shadePercent}% shaded</p>

        <h3>When does the shading occur?</h3>
        <div className="time-options">
          {shadingTimes.map((time) => (
            <button
              key={time}
              type="button"
              className={selectedTime === time ? "time-btn selected" : "time-btn"}
              onClick={() => setSelectedTime(time)}
            >
              {time}
            </button>
          ))}
        </div>

        <h3>What causes the shading?</h3>
        <div className="cause-options">
          {shadingCauses.map(({ name, emoji }) => (
            <button
              key={name}
              type="button"
              className={
                selectedCauses.includes(name)
                  ? "cause-btn selected"
                  : "cause-btn"
              }
              onClick={() => toggleCause(name)}
            >
              <span className="emoji">{emoji}</span> {name}
            </button>
          ))}
        </div>

        <button className="continue-button" onClick={handleContinue}>
          Continue
        </button>
      </div>
    </div>
  );
}
